<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div>
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item>
            <el-cascader
              ref="regionCascader"
              :options="regionData"
              :props="regionProps"
              v-model="checkedRegionData"
              placeholder="省市县"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item prop="cooperativeName">
            <el-input
              v-model="filterForm.cooperativeName"
              placeholder="合作社名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="socialCreditCode">
            <el-input
              v-model="filterForm.socialCreditCode"
              placeholder="企业信用代码"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-cascader
              ref="regionCascader"
              :options="businessZoneList"
              :props="zoneProps"
              v-model="checkedZone"
              placeholder="业务区域"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item prop="businessPersonId">
            <el-select
              v-model="filterForm.businessPersonId"
              placeholder="业务负责人"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="(item, index) in dutyPersonList"
                :key="index"
                :label="item.personName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilter()">查询</el-button>
            <el-button
              type="primary"
              plain
              icon="el-icon-refresh-right"
              @click="handleReset('filterForm')"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main">
      <el-table
        @selection-change="selectionChange"
        :data="tableData"
        style="width: 100%; margin-top: 10px"
      >
        <el-table-column type="selection" min-width="2%"></el-table-column>
        <el-table-column label="序号" min-width="5%" align="center">
          <template slot-scope="scope">
            {{ (pagination.page - 1) * pagination.size + (scope.$index + 1) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="所在地"
          min-width="25%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="cooperativeName"
          label="合作社名称"
          min-width="15%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="mobile"
          label="账号"
          min-width="15%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="socialCreditCode"
          label="企业信用代码"
          min-width="20%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="directorName"
          label="理事长"
          min-width="10%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="zoneName"
          label="业务区域"
          min-width="10%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="personName"
          label="业务负责人"
          min-width="10%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="newBusinessName"
          label="最新业务进展"
          min-width="12%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="newBusinessTime"
          label="时间"
          min-width="15%"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              plain
              round
              size="small"
              @click="lookDetail(row)"
              >查看</el-button
            >
            <el-button
              type="primary"
              plain
              round
              size="small"
              @click="onSettingBtnClick(row)"
            >
              配置
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="btn-footer">
        <el-button
          type="primary"
          class="handle-btn"
          @click="changeAreaOrSalesman"
          >更换业务区域和业务员</el-button
        >
      </div>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="pagination.size"
        :total="pagination.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
      <ChangeDialog
        v-if="showDialog"
        @close="close"
        :showDialog="showDialog"
        :dataList="multipleSelection"
        type="coo"
        @refreshList="getCooperativeList"
      ></ChangeDialog>
    </div>
  </el-main>
</template>

<script>
import regionLibs from "utils/regionSeatLibs";
import ChangeDialog from "./ChangeDialog";
let regionData = JSON.parse(JSON.stringify(regionLibs[0].c));
export default {
  name: "CooperativeManageList",
  data() {
    return {
      filterForm: {
        provinceId: "",
        cityId: "",
        areaId: "",
        cooperativeName: "",
        directorName: "",
        businessZoneId: "", //业务区域id
        businessPersonId: "", //业务负责人id
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      tableData: [],

      checkedRegionData: [],
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
      },
      regionData,

      businessZoneList: [], //业务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [], //业务负责人数据
      showDialog: false, // 弹窗
      multipleSelection: [], // 多选
    };
  },
  components: { ChangeDialog },
  filters: {},
  watch: {
    checkedRegionData(newVal) {
      this.filterForm.provinceId = newVal[0] || "";
      this.filterForm.cityId = newVal[1] || "";
      this.filterForm.areaId = newVal[2] || "";
    },
    checkedZone(newVal) {
      this.filterForm.businessPersonId = "";
      this.dutyPersonList = [];
      this.filterForm.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
  },
  created() {
    this.getCooperativeList();
    this.getBusinessZoneData();
  },
  mounted() {},
  methods: {
    /**
     * @description
     * @Author quwandong
     * @Date 2023-10-17 20:29:42
     */
    onSettingBtnClick(row) {
      this.$router.push({
        path: "/cooperative/management/setting",
        query: {
          masterId: row.accountId,
        },
      });
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-12 17:58:25
     */
    close() {
      this.showDialog = false;
    },
    /**
     * @description: 多选
     * @Author: yangsibo
     * @Date: 2022-05-18 14:56:05
     * @param val
     */
    selectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.filterForm.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 查询
    handleFilter() {
      this.pagination.page = 1;
      this.getCooperativeList();
    },
    //获取列表数据
    getCooperativeList() {
      let params = Object.assign({}, this.filterForm, {
        currentPage: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.$http.cooperative.cooperativeListFilter(params).then((res) => {
        this.tableData = res.data.content;
        if (this.pagination.page == 1)
          this.pagination.total = res.data.recordTotal;
      });
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.checkedRegionData = [];
      this.checkedZone = [];
      setTimeout(() => {
        this.handleFilter();
      }, 500);
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getCooperativeList();
    },
    /**
     * @description: 更改区域或业务员
     * @Author: yangsibo
     * @Date: 2022-05-18 15:27:45
     * @param id
     * @return {*}
     */
    changeAreaOrSalesman() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请先勾选要操作的数据",
          duration: 2000,
        });
        return;
      }
      this.showDialog = true;
    },
    /**
     * @description: 查看合作社
     * @Author: quwandong
     * @Date: 2022-05-18 15:27:45
     * @param row
     */
    lookDetail(row) {
      const routeResolve = this.$router.resolve({
        path: "/cooperative/trustee/contract",
        query: {
          $businessId: row.id,
          $businessName: row.cooperativeName,
          $businessType: "_blank",
          $businessAccountId: row.accountId,
          $backPath: this.$route.path,
        },
      });

      window.open(routeResolve.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.btn-footer {
  width: 100%;
  display: flex;
  justify-content: right;
  margin: 15px 0;
}
</style>
